import { render, staticRenderFns } from "./PlanPrice.vue?vue&type=template&id=11f68f7c&scoped=true&"
import script from "./PlanPrice.vue?vue&type=script&lang=js&"
export * from "./PlanPrice.vue?vue&type=script&lang=js&"
import style0 from "./PlanPrice.vue?vue&type=style&index=0&id=11f68f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f68f7c",
  null
  
)

export default component.exports